import { IconArrowSlideBar, TopBarArrowIcon, TopBarArrowRotatedIcon, IconLock, IconGift, IconPointsStar, IconStarX2 } from "../elements/index.js";
import { useEffect, useRef, useState, memo } from "react";
import useOutsideAlerter from "../../hooks/useOutsideAlerter.jsx";
import { BgImage } from './animations/Sky';
import { useParams, NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { openGamesCount } from "../../config";
import { colors } from "./Navbar/assets/constants";
import { useSelector, useDispatch } from "react-redux";
import { getCollectionId } from "../../hooks/getGameId";
import { getProfileGameThunk, getTotalScoreThunk, syncSectionScoreThunk } from "../../redux/features/gamesSlice";


////////// edit logic for count slide
const getSlideWidth = () => {

    if (window.innerWidth < 1024) {
        return 130;
    }
    if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        return 152 + 38;
    }
    if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        return 165 + 45;
    }
    if (window.innerWidth >= 1920) {
        return 206 + 65;
    }

}
/*
const getWidth = (arr, isSettingsOpen) => {
    if (window.innerWidth < 1024) {
        if (arr[0].name === "Coming") return Math.min(window.innerWidth, 150 * arr.length);
        return Math.min(window.innerWidth, 118 * arr.length);
    }

    if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        if (isSettingsOpen) {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 200 * arr.length);
            return Math.min(window.innerWidth - 207, (1520 + 23) * arr.length);
        } else {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 200 * arr.length);
            return Math.min(window.innerWidth - 24, (152 + 23) * arr.length);
        }
    }

    if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        if (isSettingsOpen) {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 280 * arr.length);
            return Math.min(window.innerWidth - 222, (165 + 39) * arr.length);
        } else {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 280 * arr.length);
            return Math.min(window.innerWidth - 34, (165 + 39) * arr.length);
        }
    }

    if (window.innerWidth >= 1920) {
        if (isSettingsOpen) {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 350 * arr.length);
            return Math.min(window.innerWidth - 328, (206 + 65) * arr.length);
        } else {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 350 * arr.length);
            return Math.min(window.innerWidth - 34, (206 + 65) * arr.length);
        }
    }
}
*/

const getWidth = (arr, isSettingsOpen) => {
    if (window.innerWidth < 1024) {
        if (arr[0].name === "Coming") return Math.min(window.innerWidth, 150 * arr.length);
        return window.innerWidth;
    }

    if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
        if (isSettingsOpen) {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 200 * arr.length);
            return window.innerWidth - 207;
        } else {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 200 * arr.length);
            return window.innerWidth - 24;
        }
    }

    if (window.innerWidth >= 1440 && window.innerWidth < 1920) {
        if (isSettingsOpen) {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 280 * arr.length);
            return window.innerWidth - 222;
        } else {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 280 * arr.length);
            return window.innerWidth - 34;
        }
    }

    if (window.innerWidth >= 1920) {
        if (isSettingsOpen) {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 350 * arr.length);
            return window.innerWidth - 328;
        } else {
            if (arr[0].name === "Coming") return Math.min(window.innerWidth, 350 * arr.length);
            return window.innerWidth - 34;
        }
    }
}


export default memo(function TopBar({ items, openScore, gameindex, state, level, screen, handleSubscription, subscription, days }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { name } = useParams();
    const gamesData = useSelector((state) => state.games.gameData);
    const [index, setIndex] = useState(gameindex);
    const [update, setUpdate] = useState(false);
    const [scrollRight, setScrollRight] = useState(false);
    const [scrollLeft, setScrollLeft] = useState(false);
    const arr = [...items];
    const wrapperRef = useRef(null);
    const sliderRef = useRef(null);
    const [isSettingsOpen, setIsSettingsOpen] = useState(() => {
        const storedIsOpen = localStorage.getItem("leftBarIsOpen");
        return storedIsOpen ? JSON.parse(storedIsOpen) : true;
    });
    const selectedProfile = useSelector(
        state => state.user.selectedProfile
    );

    const [isTopBarOpen, setIsTopBarOpen] = useState(() => {
        const storedIsOpen = localStorage.getItem("topBarIsOpen");
        return storedIsOpen ? JSON.parse(storedIsOpen) : true;
    }

    );
    useEffect(() => {
        localStorage.setItem("topBarIsOpen", JSON.stringify(isTopBarOpen));

        window.dispatchEvent(
            new Event("topBarIsOpenChange")
        );
    }, [isTopBarOpen]);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <IconArrowSlideBar className={className} direction="left" scroll={scrollRight} onClick={onClick} />
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <IconArrowSlideBar className={className} direction="right" scroll={scrollLeft} onClick={onClick} />
        );
    }




    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: window.innerWidth < 736 ? 2 : Math.floor(getWidth(arr, isSettingsOpen) / getSlideWidth()),
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        beforeChange: (current, next) => {
            if (arr.length === settings.slidesToShow) return;
            if (next === arr.length - (settings.slidesToShow)) {
                setScrollRight(false);
                setScrollRight(true);
                if (arr.length <= 1) {
                    setScrollRight(false);
                    setScrollLeft(false);
                }
            } else {
                if (next) {
                    setScrollLeft(true);
                } else {
                    setScrollRight(true);
                    if (arr.length <= 1) {
                        setScrollRight(false);
                        setScrollLeft(false);
                    }
                }

            }
        },
        afterChange: (current, next) => {
            if (arr.length === settings.slidesToShow) return;
            if (current === 0) {
                setScrollLeft(false);
            } else {
                if (current === arr.length - (settings.slidesToShow)) {
                    setScrollRight(false)
                    setScrollLeft(true)
                } else {
                    setScrollRight(true)
                }

            }
        },
    };

    const gameStorage = JSON.parse(localStorage.getItem('playedGames'));


    const getGameData = (gameName) => {
        if (gameStorage[name]) {

            return gameStorage[name].find((game) => game.name === gameName);
        } else {
            return null;
        }
    }

    useEffect(() => {
        setUpdate(!update);
    }, [state]);

    useEffect(() => {
        setIndex("");
        if (subscription && JSON.parse(localStorage.getItem('profile'))) {
            dispatch(getProfileGameThunk({
                userId: localStorage.getItem('user'),
                collection: name,
                profileId: JSON.parse(localStorage.getItem('profile'))._id
            }))
            dispatch(getTotalScoreThunk({
                userId: localStorage.getItem('user'),
                profileId: JSON.parse(localStorage.getItem('profile'))._id
            }))
        }
    }, [items]);

    useEffect(() => {
        const handleLeftBarIsOpenChange = () => {
            const storedIsOpen = localStorage.getItem("leftBarIsOpen");
            setIsSettingsOpen(storedIsOpen ? JSON.parse(storedIsOpen) : false);
        };

        window.addEventListener("leftBarIsOpenChange", handleLeftBarIsOpenChange);

        return () => {
            window.removeEventListener("leftBarIsOpenChange", handleLeftBarIsOpenChange);
        };
    }, []);

    useOutsideAlerter(wrapperRef, () => {
        if (window.innerWidth < 1024) {
            //setIsTopBarOpen(false);
        }
    });

    useEffect(() => {
        setIndex("");
    }, [openScore])

    useEffect(() => {
        sliderRef.current && sliderRef.current.slickGoTo(0)

        if (arr.length > settings.slidesToShow) {
            setScrollRight(true);
            setScrollLeft(false);
            if (arr.length <= 1) {
                setScrollRight(false);
                setScrollLeft(false);
            }
        } else {
            setScrollRight(false);
            setScrollLeft(false);
        }
    }, [screen, name, isSettingsOpen])


    const currentDays = days || Number(localStorage.getItem("days"))



    return (
        <div
            className={` no-scrollbar w-full relative transition-all duration-[100] flex items-center z-[40]`}>
            {/* isTopBarOpen && <BgImage /> */}
            <div className={`w-full mx-auto flex flex-col justify-center items-center`} ref={wrapperRef}>
                <div className="bg-[#E6EBE0] w-full flex flex-col">
                    <div style={{ width: getWidth(arr, isSettingsOpen) + 'px' }} className={` slider-container 
              ${isTopBarOpen
                            ? "h-[168px] sm:h-[80px] md:h-[109px] lg:h-[122px] xl:h-[145px] py-[0px] mx-auto "
                            : "h-0  py-0"
                        }
               slider-container`
                    }>
                        {isTopBarOpen && <Slider ref={sliderRef} {...settings} className="mx-[24px] md:mx-[28px] lg:mx-[60px] xl:mx-[54px]">
                            {arr.map((item, i) =>
                                ///// main
                                <div key={i} className="relative h-[160px] sm:h-[80px] md:h-[109px] lg:h-[125px] xl:h-[150px] w-[118px] md:w-[152px] lg:w-[165px] xl:w-[206px] flex flex-col justify-center items-start">

                                    {/* name*/}


                                    <NavLink onClick={() => {
                                        if (i === index) {
                                            setIndex("");
                                        } else {
                                            setIndex(i);
                                        }
                                        if (subscription === false && (getGameData(item.name)?.giftClicked || 0) === 0 && (i > openGamesCount - 1 || (getGameData(item.name) && getGameData(item.name).count >= 1))) {
                                            handleSubscription("");
                                        }

                                    }}
                                        to={(((i > openGamesCount - 1) && ((getGameData(item.name)?.giftClicked || 0) === 0)) || (getGameData(item.name) && getGameData(item.name).count >= 1)) && subscription === false ? '' : i === index ? `/games/${name}` : `/games/${name}/${item ? item.name : ''}`}
                                        className={`mx-auto ${isTopBarOpen ? "duration-500" : "invisible "
                                            } h-[98px] w-[158px] sm:h-[64px] sm:w-[96px] sm:h-[54px] sm:w-[88px] lg:h-[84px] xl:h-[95px] md:h-[75px] md:w-[120px] lg:w-[131.2px] flex justify-center xl:w-[163.2px] z-20 rounded-[5px] `}
                                    >

                                        <div className="flex flex-col items-center">
                                            <div style={{ color: colors[name] }} className="flex flex-shrink-0 items-center justify-center text-center w-full truncate text-[16px] sm:text-[10px] md:text-[12px] md:pb-[4px] pt-[0px] md:pt-[0px] lg:pb-[4px] lg:pt-[0px] lg:text-[14px] xl:text-[15px] xl:pt-[3px] font-fredokaOne"
                                            >
                                                {item ? +item.name[item.name.length - 1] ? t(`${item.name.split("_")[0]}`) + " " + item.name.split("_")[1] :
                                                    (name === "schulte" || item.name === "classic_desc" || item.name === "classic_asc") ? t(`${item.name.slice(0, item.name.lastIndexOf("_"))}`) : t(`${item.name}`) : ''}
                                                {(name === "schulte" || item.name === "classic_desc" || item.name === "classic_asc") && <img className="ml-[2px]" src={`/backGrounds/Topbar/schulte/${item.name.split("_")[item.name.split("_").length - 1]}.svg`} />}
                                            </div>


                                            { /*/////// img */}
                                            <div className="flex flex-col sm:flex-row items-center sm:items-start">


                                                <div
                                                    className={`flex-shrink-0 w-[100%] sm:h-[100%] relative rounded-[5px] 
                                                        ${i === gameindex ? 'border-2 border-[#2F9EBA]' : 'border-0 border-transparent'
                                                        }`}
                                                >
                                                    <img
                                                        alt="image"
                                                        className="w-[100%] h-[100%] rounded-[5px]"
                                                        src={`/backGrounds/Topbar/${name}/${item.name}.svg`}
                                                    />
                                                </div>



                                                {arr[i].name === "Coming" &&
                                                    <img
                                                        src="/com_s.svg"
                                                        className="absolute
                                        top-5
                                        right-5
                                        w-[30px] h-[30px]
                                        md:w-[50px] md:h-[50px]
                                        translate-x-0
                                        md:translate-x-0"
                                                    />
                                                }


                                                { /*/////// icons */}

                                                <div className="
                                                                flex flex-row sm:flex-col
                                                                justify-center sm:justify-start
                                                                items-center
                                                                gap-[12px] sm:gap-0
                                                                mt-[4px] sm:mt-0
                                                                lg:ml-[5px] md:ml-[3px] ml-[1px]
                                                                xl:space-y-[4px]  sm:space-y-[3px]
                                                            ">
                                                    {arr[i].name !== "Coming" && !(subscription === false && ((getGameData(item.name)?.doubleScore || 0) === 1 || ((getGameData(item.name)?.giftClicked || 0) === 0 && (i > openGamesCount - 1)) || (getGameData(item.name) && getGameData(item.name).count >= 1))) && currentDays > 0 && (



                                                        <div style={{ borderColor: colors[name] }}

                                                            className="
                                                            xl:w-[42px] xl:h-[30.5px]
                                                            lg:w-[37px] lg:h-[26px]
                                                            md:w-[33px] md:h-[22.5px]
                                                            sm:w-[25px] sm:h-[16px]
                                                            w-[44px] h-[30px]

                                             border-[1px] border-purple-500 rounded-[4px] bg-[#fff] cursor-pointer flex items-center justify-center"
                                                            title="Spend 1 gift for a second chance?"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                const event = new CustomEvent("showModal_b", { detail: { itemName: item.name } });
                                                                window.dispatchEvent(event);
                                                            }}>
                                                            <IconStarX2 color={colors[name]} className="
                                                         w-[90%] h-[90%]
                                                    " />
                                                        </div>
                                                    )}
                                                    {subscription && (getCollectionId(name, i) in gamesData) &&
                                                        <div className="rounded-[4px] bg-[#E6EBE0] font-dangrek 
                                             text-[16px]
                                             xl:w-[42px] xl:h-[30.5px]
                                             lg:w-[37px] lg:h-[26px]
                                             md:w-[33px] md:h-[22.5px]
                                             sm:w-[25px] sm:h-[16px]
                                                            w-[44px] h-[30px]
                                              text-[#78A941] border-[#78A941] bg-[#fff] border-[1px] absolute left-[77%]  xl:left-[80%] xl:translate-x-[-50%] translate-y-[-50%] text-center">
                                                            {gamesData[getCollectionId(name, i)]?.count}
                                                        </div>
                                                    }
                                                    {subscription === false && (((getGameData(item.name)?.giftClicked || 0) === 0 && (i > openGamesCount - 1)) || (getGameData(item.name) && getGameData(item.name).count >= 1)) &&
                                                        <div
                                                            style={{ borderColor: colors[name] }}
                                                            className=" rounded-[4px] bg-[#fff] border-[1px] flex items-center justify-center
                                                            xl:w-[42px] xl:h-[30.5px]
                                                            lg:w-[37px] lg:h-[26px]
                                                            md:w-[33px] md:h-[22.5px]
                                                            sm:w-[25px] sm:h-[16px]
                                                            w-[44px] h-[30px]
                                                    ">
                                                            <IconLock
                                                                color={colors[name]}
                                                                className="
                                                        w-[90%] h-[95%]
                                                    "
                                                            />
                                                        </div>}




                                                    {subscription === false && (((getGameData(item.name)?.giftClicked || 0) === 0 && (i > openGamesCount - 1)) || (getGameData(item.name) && getGameData(item.name).count >= 1)) && currentDays > 0 && (
                                                        <div style={{ borderColor: colors[name] }}

                                                            className="
                                                            xl:w-[42px] xl:h-[30.5px]
                                                            lg:w-[37px] lg:h-[26px]
                                                            md:w-[33px] md:h-[22.5px]
                                                            sm:w-[25px] sm:h-[16px]
                                                            w-[44px] h-[30px]
                                                    border-[1px] border-purple-500 rounded-[4px] bg-[#fff] cursor-pointer flex items-center justify-center"
                                                            title="Spend 1 gift for a second chance?"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                const event = new CustomEvent("showModal_g", { detail: { itemName: item.name, overLimit: i > openGamesCount - 1 } });
                                                                window.dispatchEvent(event);
                                                            }}>
                                                            <IconGift className="
                                                        w-[90%] h-[90%]
                                                    " />
                                                        </div>


                                                    )}

                                                    {(() => {
                                                        const collectionId = getCollectionId(name, i);

                                                        if (subscription) {
                                                            const points = gamesData?.[collectionId]?.points;
                                                            if (points === undefined) return null;

                                                            return (
                                                                <div
                                                                    style={{ borderColor: colors[name] }}
                                                                    className=" relative
                                                                    xl:w-[42px] xl:h-[30.5px]
                                                            lg:w-[37px] lg:h-[26px]
                                                            md:w-[33px] md:h-[22.5px]
                                                            sm:w-[25px] sm:h-[16px]
                                                            w-[44px] h-[30px]
                                                            border-[1px] rounded-[4px] bg-[#fff] cursor-pointer "
                                                                    title="Your points"
                                                                >
                                                                    <IconPointsStar className="absolute -left-1 -bottom-1 w-[90%] h-[90%] " />

                                                                    <span className={`absolute right-1 xl:-top-[4px] md:-top-[3px] -top-[2px] font-bold font-fredokaOne
                                                        ${points < 100
                                                                            ? "xl:text-[16px] lg:text-[14px] md:text-[12px] text-[9px]"
                                                                            : points < 1000
                                                                                ? "xl:text-[12px] lg:text-[10px] md:text-[9px] text-[7px]"
                                                                                : "xl:text-[10px] lg:text-[8px] md:text-[7px] text-[5px]"
                                                                        } `}
                                                                        style={{ color: colors[name] }}
                                                                    >
                                                                        {points}
                                                                    </span>
                                                                </div>
                                                            );
                                                        }

                                                        const game = getGameData(item.name);
                                                        if (!game || game.point <= 0) return null;

                                                        const localPoints =
                                                            game.point;

                                                        return (
                                                            <div
                                                                style={{ borderColor: colors[name] }}
                                                                className=" relative
                                                                xl:w-[42px] xl:h-[30.5px]
                                                                lg:w-[37px] lg:h-[26px]
                                                                md:w-[33px] md:h-[22.5px]
                                                                sm:w-[25px] sm:h-[16px]
                                                            w-[44px] h-[30px]
                                                        border-[1px] rounded-[4px] bg-[#fff] cursor-pointer "
                                                                title="Your points"
                                                            >
                                                                <IconPointsStar className="absolute -left-1  xl:-bottom-[4px] md:-bottom-[3px] -bottom-[2px] w-[90%] h-[90%] " />
                                                                <span className={`absolute md:right-[3px] sm:right-[2px] right-[5px]  md:-top-[3px] -top-[2px] font-bold font-fredokaOne
                                                        ${localPoints < 100
                                                                        ? "xl:text-[16px] lg:text-[14px] md:text-[12px] sm:text-[9px] text-[15px]"
                                                                        : localPoints < 1000
                                                                            ? "xl:text-[12px] lg:text-[10px] md:text-[9px] sm:text-[7px] text-[12px]"
                                                                            : "xl:text-[10px] lg:text-[8px] md:text-[7px] sm:text-[5px] text-[10px]"
                                                                    } `}
                                                                    style={{ color: colors[name] }}
                                                                >
                                                                    {localPoints}
                                                                </span>
                                                            </div>
                                                        );
                                                    })()}
                                                </div>
                                            </div>
                                        </div>


                                    </NavLink>


                                </div>
                            )
                            }
                        </Slider>}
                    </div>
                </div>
                {isTopBarOpen ?
                    <div
                        onClick={() => {
                            setIsTopBarOpen((prevState) => !prevState);
                        }}
                        className="absolute cursor-pointer z-30 mt-[4px] sm:mt-[0px] h-[31px] md:h-[34px] lg:h-[36px] xl:h-[43px]  w-[53px] lg:w-[54px] xl:w-[58px] top-[95%]">
                        <TopBarArrowRotatedIcon
                            className={`transition-transform duration-1000 group-hover:duration-500 h-[31px] md:h-[34px] lg:h-[36px]  xl:h-[43px]  w-[53px] lg:w-[54px] xl:w-[58px]`}
                        />
                    </div> :
                    <div
                        onClick={() => {
                            setIsTopBarOpen((prevState) => !prevState);
                        }}
                        className="absolute cursor-pointer z-30 h-[31px] md:h-[34px] lg:h-[36px] lg:mt-[7px] xl:mt-[10px]  w-[53px] lg:w-[54px] xl:h-[43px] xl:w-[58px]">
                        <TopBarArrowIcon
                            className={`top-1/2 transition-transform duration-1000 group-hover:duration-500 h-[31px] md:h-[34px] lg:h-[36px]  xl:h-[43px] w-[53px] lg:w-[54px] xl:w-[58px] mt-[10px]`}
                        />
                    </div>
                }
            </div>
        </div>

    )
})